import { Base } from "ui/Scripts/source/framework/base";
import { IUserGroupListItem, UserGroupListItem } from "ui/Scripts/source/models/userGroup/userGroupListItem";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IRecordEditNew {
    units: IIdTitleNode[];
    canReadUsers: boolean;
    canEditUsers: boolean;
    minPasswordLength: number;
    userGroups: IUserGroupListItem[];
}

export class RecordEditNew implements IRecordEditNew {
    units: IdTitleNode[];
    canReadUsers: boolean;
    canEditUsers: boolean;
    minPasswordLength: number;
    userGroups: UserGroupListItem[];

    constructor();
    constructor(obj: IRecordEditNew);
    constructor(obj?: any) {
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.canReadUsers = obj && obj.canReadUsers || false;
        this.canEditUsers = obj && obj.canEditUsers || false;
        this.minPasswordLength = obj && obj.minPasswordLength || false;
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UserGroupListItem);
    }
}